import { makeVar } from '@apollo/client';

export const selectedPracticeArea = makeVar(null);

export const appraisalComparisonCache = {
  selectedPracticeArea: {
    read: selectedPracticeArea
  }
};
